var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17 10a7 7 0 1 0-14 0 7 7 0 0 0 14 0m2 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 10a7 7 0 0 0 7 7v2a9 9 0 0 1-9-9zm7-9a9 9 0 0 1 9 9h-2a7 7 0 0 0-7-7z"
  })));
};
export { SvgLoader as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC4zIiBkPSJNMTcgMTBDMTcgNi4xMzQwMSAxMy44NjYgMyAxMCAzQzYuMTM0MDEgMyAzIDYuMTM0MDEgMyAxMEMzIDEzLjg2NiA2LjEzNDAxIDE3IDEwIDE3QzEzLjg2NiAxNyAxNyAxMy44NjYgMTcgMTBaTTE5IDEwQzE5IDE0Ljk3MDYgMTQuOTcwNiAxOSAxMCAxOUM1LjAyOTQ0IDE5IDEgMTQuOTcwNiAxIDEwQzEgNS4wMjk0NCA1LjAyOTQ0IDEgMTAgMUMxNC45NzA2IDEgMTkgNS4wMjk0NCAxOSAxMFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0zIDEwQzMgMTMuODY2IDYuMTM0MDEgMTcgMTAgMTdWMTlDNS4wMjk0NCAxOSAxIDE0Ljk3MDYgMSAxMEgzWk0xMCAxQzE0Ljk3MDYgMSAxOSA1LjAyOTQ0IDE5IDEwSDE3QzE3IDYuMTM0MDEgMTMuODY2IDMgMTAgM1YxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";